// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"Home_newsletter__1SxGh","visionlist":"Home_visionlist__2_EJs","values":"Home_values__2Dp7_"};